import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Lock, Info, Headphones } from 'lucide-react';
import { useUser } from '../../contexts/UserContext';
import { performLogout } from '../../utils/logout';
import './AccountRestricted.css';

const DEFAULT_REASON = 'Policy Violation';

/** Full-page Account Restricted card. Contact Support → /support; Logout → login. */
export default function AccountRestrictedPanel({ reason }) {
  const navigate = useNavigate();
  const { clearUserData } = useUser();
  const restrictionReason = String(reason ?? '').trim() || DEFAULT_REASON;

  const handleLogout = () => {
    performLogout(clearUserData);
    navigate('/login', { replace: true });
  };

  return (
    <div
      className="account-restricted"
      role="alertdialog"
      aria-labelledby="account-restricted-title"
      aria-describedby="account-restricted-desc"
    >
      <div className="account-restricted-card">
        <div className="account-restricted-icon-wrap" aria-hidden="true">
          <span className="account-restricted-ring account-restricted-ring--outer" />
          <span className="account-restricted-ring account-restricted-ring--mid" />
          <span className="account-restricted-ring account-restricted-ring--inner" />
          <span className="account-restricted-icon">
            <Lock size={28} strokeWidth={2.25} />
          </span>
        </div>

        <h1 id="account-restricted-title" className="account-restricted-title">
          Account Restricted
        </h1>
        <p id="account-restricted-desc" className="account-restricted-desc">
          Your account has been restricted. Access to this account has been limited. If you believe this is a
          mistake, please contact our support team.
        </p>

        <div className="account-restricted-reason">
          <span className="account-restricted-reason-icon" aria-hidden="true">
            <Info size={16} strokeWidth={2.5} />
          </span>
          <div className="account-restricted-reason-body">
            <p className="account-restricted-reason-label">
              Restriction Reason: <strong>{restrictionReason}</strong>
            </p>
            <p className="account-restricted-reason-hint">For more details, please contact support.</p>
          </div>
        </div>

        <button type="button" className="account-restricted-support-btn" onClick={() => navigate('/support')}>
          <Headphones size={18} strokeWidth={2.25} aria-hidden="true" />
          Contact Support
        </button>

        <button type="button" className="account-restricted-logout" onClick={handleLogout}>
          Logout and return to home <span aria-hidden="true">→</span>
        </button>
      </div>
    </div>
  );
}
